
const x = window.svgStrings || {};
window.svgStrings = x;

x.optionsButton = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false">
	<path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
</svg>`;

x.appLogo = null;

